export const validateOverriddingRisk = (overriddingRiskFormData) => {
    
    if (!overriddingRiskFormData) {
        return false
    }
    if (overriddingRiskFormData.overriddingRiskFactorName && overriddingRiskFormData.overriddingScore && overriddingRiskFormData.overriddingRule && overriddingRiskFormData.overriddingFactors) {
        return true
    } else {
        return false
    }
}

export const createOverriddingRiskRequestBody = (overriddingRiskFormData) => {
    let requestBody = {
        name: overriddingRiskFormData.values.overriddingRiskFactorName,
        score: overriddingRiskFormData.values.overriddingScore,
        factors : overriddingRiskFormData.values.overriddingFactors,
        rule : overriddingRiskFormData.values.overriddingRule,
        isAutomated : true
    }
    return requestBody;
}